var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup19284(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19284",
    "data-name": "Group 19284",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.633,
    height: 33.633,
    viewBox: "0 0 33.633 33.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 16.816,
    cy: 16.816,
    r: 16.816,
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M937.438,246.062v11.883",
    transform: "translate(-924.121 -235.187)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13654",
    "data-name": "Path 13654",
    d: "M937.438,246.062v11.883",
    transform: "translate(-917.121 -235.187)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19284);
export default __webpack_public_path__ + "static/media/Group 19284.f6ac55cc7f2871b81560826aadd71625.svg";
export { ForwardRef as ReactComponent };